import Immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState } from 'redux-recompose';

import { actions } from './actions';

const stateDescription = {
  disableds: null,
  prices: null
};

const initialState = completeState(stateDescription);

const reducerDescription = {
  primaryActions: [
    actions.GET_DISABLEDS,
    actions.GET_PRICES,
    actions.GET_STATIC_MENU,
    actions.BLOCK,
    actions.UNBLOCK
  ],
  override: {
    // Keeps disabledsLoading on purpose: the load ends when the chained call
    // (GET_STATIC_MENU or GET_PRICES) answers.
    [actions.GET_DISABLEDS_SUCCESS]: (state, action) => state.merge({ [action.target]: action.payload }),
    [actions.GET_STATIC_MENU_SUCCESS]: (state, action) =>
      state.merge({
        [action.target]: action.payload,
        [`${action.target}Loading`]: false,
        disabledsLoading: false
      }),
    [actions.GET_PRICES_SUCCESS]: (state, action) =>
      state.merge({
        [action.target]: action.payload,
        [`${action.target}Loading`]: false,
        disabledsLoading: false
      }),
    // End of the chain: without this disabledsLoading would stay on forever.
    // GET_STATIC_MENU_FAILURE is left out on purpose, it retries with GET_PRICES.
    [actions.GET_PRICES_FAILURE]: (state, action) =>
      state.merge({
        [`${action.target}Error`]: action.payload,
        [`${action.target}Loading`]: false,
        disabledsLoading: false
      })
  }
};

export default createReducer(new Immutable(initialState), completeReducer(reducerDescription));
